// Module
var code = "<react-component name=\"NewGrading\"></react-component>\n";
// Exports
module.exports = code;